import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { MenuModel } from 'shared/definition/menu.model';
import { MenuItemModel } from 'shared/definition';
import { AuthorizationApiService } from 'shared/services';
import { Router } from '@angular/router';

@Component({
  selector: 'mm-menu-list',
  templateUrl: './menu-list.component.html',
  styleUrls: ['./menu-list.component.scss']
})
export class MenuListComponent implements OnInit {


  constructor(
    protected authoriaztionApi: AuthorizationApiService,
    protected router: Router) {

  }

  items$ = new BehaviorSubject<MenuItemModel[]>([]);


  ngOnInit(): void {

  }

  @Input()
  set items(_: MenuItemModel[]) {
    this.items$.next(_);
  }


  @Input()
  paths: string[] = [];


  hasItems(item: MenuItemModel) {
    return item.items && item.items.length > 0;
  }

  clickMenu(item: MenuItemModel) {
    if (!item.path || item.path.trim() == '') return;
    this.router.navigate(this.itemPaths(item));
  }

  itemPaths(item: MenuItemModel) {
    return [...this.paths, item.path];
  }

  combinePaths(paths: string[], path: string) {
    return [...paths, path];

  }

  navigate(paths: string[]) {
    this.router.navigate(paths);
  }


}
